// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubaccountsLinks_CriarInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /payments/links/criar
 *
 * Creates a new payment link with polymorphic ownership.
 * Supports any owner type (compromisso, royalty, invoice, etc.)
 */
import { registerContract } from './validate'

export interface SubaccountsLinks_CriarInput {
owner_id: number
owner?: string
compromisso_id?: number
amount?: number
due_days?: number
description?: string
payment_methods?: string[]
installments?: number
notify_customer?: boolean
}

registerContract('SubaccountsLinks_CriarInput', {
  owner_id:        { type: 'number',  required: true },
  owner:           { type: 'string',  required: false },
  compromisso_id:  { type: 'number',  required: false },
  amount:          { type: 'number',  required: false },
  due_days:        { type: 'number',  required: false },
  description:     { type: 'string',  required: false },
  payment_methods: { type: 'array',   required: false },
  installments:    { type: 'number',  required: false },
  notify_customer: { type: 'boolean', required: false },
})
